__turbopack_context__.v({
  "className": "quicksand_862cf889-module__dv31yq__className",
  "variable": "quicksand_862cf889-module__dv31yq__variable",
});
